<template>
	<div class="app">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'App',
	components: {},
	mounted() {
		
	},
  mateInfo: {
    // eslint-disable-next-line no-mixed-spaces-and-tabs

  }
};
</script>
<style lang="scss">
@import './assets/sass/base.scss';
</style>
